import { EcommerceHead } from './EcommerceHead'

import { useRoomDataLayerObject } from '../../../hooks'

export const RoomIndexHead = () => {
  const dataLayerObject = useRoomDataLayerObject()

  return dataLayerObject && <EcommerceHead dataLayerObject={dataLayerObject} />
}
